/** @jsx jsx */
import { jsx, Label, Text } from 'theme-ui'

const FormLabel = ({ label, name, required }) => {
  return (
    <Label
      htmlFor={name}
      variant="text.label"
      sx={{ fontWeight: 'bold', mb: 1 }}
    >
      {label}
      {required && (
        <Text as="span" sx={{ color: 'brandTertiary', ml: '4px' }}>
          *
        </Text>
      )}
    </Label>
  )
}

export default FormLabel
